import axios from 'axios'
import { getToken } from 'utils/getTokenWithLms'
import config from 'config'

let usedToken

try {
  const { token } = getToken()
  usedToken = token
} catch (error) {
  // eslint-disable-next-line
  console.log(error)
}

export default axios.create({
  baseURL: config.env.GRAPHQL_API_URL,
  timeout: 5000,
  headers: {
    authorization: usedToken ? `Bearer ${usedToken}` : null,
  },
})
